// cspell:disable

/**
 * Represents a collection of bookIds.
 * GEN – The book of Genesis.
 * EXO – The book of Exodus.
 * LEV – The book of Leviticus.
 * NUM – The book of Numbers.
 * DEU – The book of Deuteronomy.
 * JOS – The book of Joshua.
 * JDG – The book of Judges.
 * RUT – The book of Ruth.
 * '1SA' – The book of Samuel 1.
 * '2SA' – The book of Samuel 2.
 * '1KI' – The book of Kings 1.
 * '2KI' – The book of Kings 2.
 * '1CH' – The book of Chronicles 1.
 * '2CH' – The book of Chronicles 2.
 * EZR – The book of Ezra.
 * NEH – The book of Nehemiah.
 * EST – The book of Esther (Hebrew).
 * JOB – The book of Job.
 * PSA – The book of Psalms.
 * PRO – The book of Proverbs.
 * ECC – The book of Ecclesiastes.
 * SNG – The book of Song of Songs.
 * ISA – The book of Isaiah.
 * JER – The book of Jeremiah.
 * LAM – The book of Lamentations.
 * EZK – The book of Ezekiel.
 * DAN – The book of Daniel (Hebrew).
 * HOS – The book of Hosea.
 * JOL – The book of Joel.
 * AMO – The book of Amos.
 * OBA – The book of Obadiah.
 * JON – The book of Jonah.
 * MIC – The book of Micah.
 * NAM – The book of Nahum.
 * HAB – The book of Habakkuk.
 * ZEP – The book of Zephaniah.
 * HAG – The book of Haggai.
 * ZEC – The book of Zechariah.
 * MAL – The book of Malachi.
 * MAT – The book of Matthew.
 * MRK – The book of Mark.
 * LUK – The book of Luke.
 * JHN – The book of John.
 * ACT – The book of Acts.
 * ROM – The book of Romans.
 * '1CO' – The book of Corinthians 1.
 * '2CO' – The book of Corinthians 2.
 * GAL – The book of Galatians.
 * EPH – The book of Ephesians.
 * PHP – The book of Philippians.
 * COL – The book of Colossians.
 * '1TH' – The book of Thessalonians 1.
 * '2TH' – The book of Thessalonians 2.
 * '1TI' – The book of Timothy 1.
 * '2TI' – The book of Timothy 2.
 * TIT – The book of Titus.
 * PHM – The book of Philemon.
 * HEB – The book of Hebrews.
 * JAS – The book of James.
 * '1PE' – The book of Peter 1.
 * '2PE' – The book of Peter 2.
 * '1JN' – The book of John 1.
 * '2JN' – The book of John 2.
 * '3JN' – The book of John 3.
 * JUD – The book of Jude.
 * REV – The book of Revelation.
 * TOB – The book of Tobit.
 * JDT – The book of Judith.
 * ESG – The book of Esther (Greek).
 * WIS – The book of Wisdom of Solomon.
 * SIR – The book of Sirach.
 * BAR – The book of Baruch.
 * LJE – The book of Letter of Jeremiah.
 * S3Y – The book of Song of the Three Young Men.
 * SUS – The book of Susanna.
 * BEL – The book of Bel and the Dragon.
 * '1MA' – The book of Maccabees 1.
 * '2MA' – The book of Maccabees 2.
 * '3MA' – The book of Maccabees 3.
 * '4MA' – The book of Maccabees 4.
 * '1ES' – The book of Esdras 1 (Greek).
 * '2ES' – The book of Esdras 2 (Latin).
 * MAN – The book of Prayer of Manasseh.
 * PS2 – The book of Psalm 151.
 * ODA – The book of Odae.
 * PSS – The book of Psalms of Solomon.
 * EZA – The book of Ezra Apocalypse.
 * '5EZ' – The book of Ezra 5.
 * '6EZ' – The book of Ezra 6.
 * DAG – The book of Daniel (Greek).
 * PS3 – The book of Psalms 152-155.
 * '2BA' – The book of Baruch 2 Apocalypse.
 * LBA – The book of Letter of Baruch.
 * JUB – The book of Jubilees.
 * ENO – The book of Enoch.
 * '1MQ' – The book of Meqabyan 1.
 * '2MQ' – The book of Meqabyan 2.
 * '3MQ' – The book of Meqabyan 3.
 * REP – The book of Reproof.
 * '4BA' – The book of Baruch 4.
 * LAO – The book of Letter to the Laodiceans.
 */
export const BOOK_IDs = {
	"1CH": "Chronicles_1",
	"1CO": "Corinthians_1",
	"1ES": "Esdras_1_Greek",
	"1JN": "John_1",
	"1KI": "Kings_1",
	"1MA": "Maccabees_1",
	"1MQ": "Meqabyan_1",
	"1PE": "Peter_1",
	"1SA": "Samuel_1",
	"1TH": "Thessalonians_1",
	"1TI": "Timothy_1",
	"2BA": "Baruch_2_Apocalypse",
	"2CH": "Chronicles_2",
	"2CO": "Corinthians_2",
	"2ES": "Esdras_2_Latin",
	"2JN": "John_2",
	"2KI": "Kings_2",
	"2MA": "Maccabees_2",
	"2MQ": "Meqabyan_2",
	"2PE": "Peter_2",
	"2SA": "Samuel_2",
	"2TH": "Thessalonians_2",
	"2TI": "Timothy_2",
	"3JN": "John_3",
	"3MA": "Maccabees_3",
	"3MQ": "Meqabyan_3",
	"4BA": "Baruch_4",
	"4MA": "Maccabees_4",
	"5EZ": "Ezra_5",
	"6EZ": "Ezra_6",
	ACT: "Acts",
	AMO: "Amos",
	BAR: "Baruch",
	BEL: "Bel_and_the_Dragon",
	COL: "Colossians",
	DAG: "Daniel_Greek",
	DAN: "Daniel_Hebrew",
	DEU: "Deuteronomy",
	ECC: "Ecclesiastes",
	ENO: "Enoch",
	EPH: "Ephesians",
	ESG: "Esther_Greek",
	EST: "Esther_Hebrew",
	EXO: "Exodus",
	EZA: "Ezra_Apocalypse",
	EZK: "Ezekiel",
	EZR: "Ezra",
	GAL: "Galatians",
	GEN: "Genesis",
	HAB: "Habakkuk",
	HAG: "Haggai",
	HEB: "Hebrews",
	HOS: "Hosea",
	ISA: "Isaiah",
	JAS: "James",
	JDG: "Judges",
	JDT: "Judith",
	JER: "Jeremiah",
	JHN: "John",
	JOB: "Job",
	JOL: "Joel",
	JON: "Jonah",
	JOS: "Joshua",
	JUB: "Jubilees",
	JUD: "Jude",
	LAM: "Lamentations",
	LAO: "Letter_to_the_Laodiceans",
	LBA: "Letter_of_Baruch",
	LEV: "Leviticus",
	LJE: "Letter_of_Jeremiah",
	LUK: "Luke",
	MAL: "Malachi",
	MAN: "Prayer_of_Manasseh",
	MAT: "Matthew",
	MIC: "Micah",
	MRK: "Mark",
	NAM: "Nahum",
	NEH: "Nehemiah",
	NUM: "Numbers",
	OBA: "Obadiah",
	ODA: "Odae",
	PHM: "Philemon",
	PHP: "Philippians",
	PRO: "Proverbs",
	PS2: "Psalm_151",
	PS3: "Psalms_152_155",
	PSA: "Psalms",
	PSS: "Psalms_of_Solomon",
	REP: "Reproof",
	REV: "Revelation",
	ROM: "Romans",
	RUT: "Ruth",
	S3Y: "Song_of_the_3_Young_Men",
	SIR: "Sirach",
	SNG: "Song_of_Songs",
	SUS: "Susanna",
	TIT: "Titus",
	TOB: "Tobit",
	WIS: "Wisdom_of_Solomon",
	ZEC: "Zechariah",
	ZEP: "Zephaniah",
} as const;
